import { lowerFirst } from "lodash";
import type { FormValues } from "@/widgets/classic-form/form";
import type { FieldMapperProps } from "@/features/fields-grid";
import type { RelationshipAssertion } from "@/entities/form-metadata";
import { NameAssertion } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";
import { NameInput } from "./NameInput";
import { useFamilyMemberFieldFocusTracking } from "./useFamilyMemberFieldFocusTracking";

export function FieldMapper({
    fieldData,
    fieldPath,
    assertion,
    relation,
    inputProperties,
}: FieldMapperProps<RelationshipAssertion>) {
    const getFocusTracking = useFamilyMemberFieldFocusTracking();

    if ([NameAssertion.GivenName, NameAssertion.Surname, NameAssertion.SecondSurname].includes(assertion)) {
        const { onFocus } = getFocusTracking(relation, assertion);

        return (
            <NameInput
                metadata={fieldData}
                basePath={`${fieldPath}.${lowerFirst(assertion)}` as PrefixObjectAccessor<FormValues, []>}
                inputProperties={{ ...inputProperties, onFocus }}
            />
        );
    }

    // TODO: add here new relic error log
    return null;
}
